export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, GroupsResource) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
    }

    saveGroupName(groupName) {
        return this.GroupsResource
            .renameGroup(this.companyId, this.group.id, groupName)
            .then(() => this.$state.reload('company.user-directories'))
            .then(() => this.Alert('success', 'company.user-directories.manage-group.settings.renamed'));
    }

    showRemoveModal() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageGroupRemove',
                resolve: {
                    companyId: () => this.companyId,
                    groupId: () => this.group.id,
                },
            }).result
            .then(() => {
                if (this.group.type == 'CUSTOM') {
                    this.$state.go('company.user-directories.directory-groups.directory', {directoryId: 'saaspass-cloud-directory'})
                } else {
                    this.$state.go('company.user-directories.directory-groups.directory', {directoryId: this.group.directory.id})
                }
            })
            .then(() => {
                const key = 'company.user-directories.manage-group.remove.removed';
                const variables = {groupName: this.group.groupName};
                this.Alert('success', key, variables);
            })
    }

    isDeletable() {
        let type = this.group.type
        return type == 'CUSTOM' || type == 'AZURE_AD' || type == 'SCIM_DIRECTORY';
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/settings/group-settings.controller.js